









































































































import { $eventsBus } from "@/main";
import Vue from "vue";
import { TimeHelper } from "../../classes/helpers/TimeHelper";

export default Vue.extend({
  name: "CenterPanel",
  components: {},
  data: function () {
    return {
      isPaused: true,
      isPlayingForceDisable: false,
      videoTimeIntervalListner: null,
      currentPartIndexInMixedParts: 0,
    };
  },
  computed: {
    items() {
      return this.$store.state.items;
    },
    itemsToShow: function () {
      return this.$store.state.items.filter((i) => !i.hidden);
    },
    contentDuration: function () {
      let duration = 0;
      this.$store.state.items
        .filter((i) => !i.hidden)
        .forEach((item) => {
          duration += item.duration;
        });
      return duration;
    },
    mixedPartsDuration: function () {
      let duration = 0;
      this.$store.state.mixedParts.forEach((part) => {
        duration += part.finishTime - part.startTime;
      });
      return duration;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    showDownloadPanel: function () {
      return this.$store.state.showDownloadPanel;
    },
    contentVideoCurrentTime: {
      get: function () {
        return this.$store.state.contentVideoCurrentTime;
      },
      set: function (value) {
        this.$store.commit("contentVideoCurrentTime", value);
      },
    },
    muted: {
      get: function () {
        return this.$store.state.muted;
      },
      set: function (muted) {
        this.$store.commit("muted", muted);
      },
    },
    mixedParts: {
      get: function () {
        return this.$store.state.mixedParts;
      },
      set: function (mixedParts) {
        this.$store.commit("mixedParts", mixedParts);
      },
    },
    isMixerStep: {
      get: function () {
        return this.$store.state.isMixerStep;
      },
      set: function (isMixerStep) {
        this.$store.commit("isMixerStep", isMixerStep);
      },
    },
    selectedPart: {
      get: function () {
        return this.$store.state.selectedPart;
      },
      set: function (part) {
        this.$store.commit("changeSelectedPart", part);
      },
    },
    audioParameters: function () {
      return this.$store.state.audioParameters;
    },
  },
  watch: {
    isPaused: function () {
      this.setVideoPlaying(this.isPaused);
      this.setMusicPlaying(this.isPaused);
    },
    muted: function () {
      this.muteSound(this.muted);
      this.muteMusicSound(this.muted);
    },
    previewItem: function () {
      if (!!this.previewItem) {
        this.onVideoTimeUpdate(this.$refs.contentVideo);
      }
      this.updatePlayingContent();
    },
    audioParameters: {
      deep: true,
      handler() {
        this.setVolume(this.audioParameters.volume);
        this.setMusicVolume(this.audioParameters.musicVolume);
      },
    },
  },
  created() {
    $eventsBus.$on("setContentCurrentVideoTime", (newTime) => {
      this.setVideoTime(newTime);
      this.setMusicTime(newTime);
    });
    $eventsBus.$on("setContentTime", (newTime) => {
      this.setContentTime(newTime);
    });
    $eventsBus.$on("setVideoPaused", (isPaused) => {
      this.isPaused = isPaused;
      this.setVideoPlaying(isPaused);
      this.setMusicPlaying(isPaused);
    });
    $eventsBus.$on("isPlayingForceDisable", (isPlayingForceDisable) => {
      this.isPlayingForceDisable = isPlayingForceDisable;
      this.updatePlayingContent();
    });
    window.onkeydown = this.onKeyDown;
  },
  mounted() {
    this.updatePlayingContent();
  },
  methods: {
    onPlayVideo(event) {
      clearInterval(this.videoTimeIntervalListner);
      this.videoTimeIntervalListner = setInterval(() => {
        if (!this.previewItem) {
          clearInterval(this.videoTimeIntervalListner);
        } else {
          this.onVideoTimeUpdate(this.$refs.contentVideo);
        }
      }, 40);
    },
    onPauseVideo(event) {
      clearInterval(this.videoTimeIntervalListner);
    },
    onKeyDown(event) {
      if (event.code === "Space") {
        $eventsBus.$emit("setVideoPaused", !this.isPaused);
      }
    },
    onVideoTimeUpdate(target) {
      /*       if (e.target.currentTime === 0) {
        return;
      } */
      if (!this.isMixerStep) {
        this.contentVideoCurrentTime =
          this.getDurationOfPreviousItemsToShow(this.previewItem) +
          target.currentTime;
      } else {
        /* Получаем текущий part суммируем предыдущие.
		Обновляем время.
		Обновляем видео part (в том числе previewItem), если время вышло за рамки part */
        if (
          !!this.selectedPart &&
          this.previewItem.id !== this.selectedPart.parentItemInfo.id
        ) {
          this.$store.commit(
            "changeSelectItem",
            this.items.find((i) => i.id === this.selectedPart.parentItemInfo.id)
          );
          this.setVideoTime(this.selectedPart.startTime);
          this.setMusicPlaying(this.isPaused);
          this.setMusicTime(this.contentVideoCurrentTime);
          return;
        }
        this.contentVideoCurrentTime = 0;
        let currentPartIndex = this.currentPartIndexInMixedParts;
        //let currentPartIndex = this.mixedParts.indexOf(this.selectedPart);
        this.selectedPart = this.mixedParts[currentPartIndex];
        for (let index = 0; index < currentPartIndex; index++) {
          let part = this.mixedParts[index];
          this.contentVideoCurrentTime += part.finishTime - part.startTime;
        }
        let partTimeShift = target.currentTime - this.selectedPart.startTime;
        if (partTimeShift < 0) {
          this.setVideoTime(this.selectedPart.startTime);
        } else if (
          partTimeShift >
          this.selectedPart.finishTime - this.selectedPart.startTime
        ) {
          this.contentVideoCurrentTime +=
            this.selectedPart.finishTime - this.selectedPart.startTime;
          this.currentPartIndexInMixedParts =
            currentPartIndex !== this.mixedParts.length - 1
              ? currentPartIndex + 1
              : 0;
          this.selectedPart = this.mixedParts[
            this.currentPartIndexInMixedParts
          ];
          this.$store.commit(
            "changeSelectItem",
            this.items.find((i) => i.id === this.selectedPart.parentItemInfo.id)
          );
          this.setVideoTime(this.selectedPart.startTime);
        } else {
          this.contentVideoCurrentTime += partTimeShift;
        }
        this.setMusicPlaying(this.isPaused);
        this.setMusicTime(this.contentVideoCurrentTime);
      }
      $eventsBus.$emit("contentTimeUpdated");
    },
    onVideoEnded() {
      if (!this.isMixerStep) {
        let currentIndex = this.itemsToShow.indexOf(this.previewItem);
        let nextItem = this.itemsToShow[
          currentIndex + 1 === this.itemsToShow.length ? 0 : currentIndex + 1
        ];
        this.selectItem(nextItem);
      }
    },
    onLoadVideo(e) {
      this.updatePlayingContent();
    },
    onLoadMusic(e) {
      this.updatePlayingContent();
    },
    updatePlayingContent() {
      this.setVolume(this.audioParameters.volume);
      this.muteSound(this.muted);
      this.setVideoPlaying(this.isPaused);

      this.setMusicVolume(this.audioParameters.musicVolume);
      this.muteMusicSound(this.muted);
      this.setMusicPlaying(this.isPaused);
    },
    safeSetVideoTime(time) {
      let contentVideo = this.$refs.contentVideo;
      if (contentVideo && contentVideo.readyState >= 1) {
        this.setVideoTime(time);
      } else {
        setTimeout(() => {
          this.safeSetVideoTime(time);
        }, 5);
      }
    },
    setContentTime(contentTime) {
      if (!this.isMixerStep) {
        let durationBefore = 0;
        for (let index = 0; index < this.itemsToShow.length; index++) {
          let item = this.itemsToShow[index];
          if (
            contentTime >= durationBefore &&
            contentTime <= durationBefore + item.duration
          ) {
            if (this.previewItem !== item) {
              this.selectItem(item);
            }
            setTimeout(() => {
              this.safeSetVideoTime(contentTime - durationBefore);
            }, 2);
            break;
          } else {
            durationBefore += item.duration;
          }
        }
      } else {
        let durationBefore = 0;
        for (let index = 0; index < this.mixedParts.length; index++) {
          let part = this.mixedParts[index];
          let partDuration = part.finishTime - part.startTime;
          if (
            contentTime >= durationBefore &&
            contentTime <= durationBefore + partDuration
          ) {
            if (this.selectedPart !== part) {
              this.selectedPart = part;
              this.currentPartIndexInMixedParts = index;
              if (this.previewItem.id !== part.parentItemInfo.id) {
                let item = this.items.find(
                  (i) => i.id === this.selectedPart.parentItemInfo.id
                );
                this.selectItem(item);
              }
            } else {
              if (this.currentPartIndexInMixedParts !== index) {
                this.currentPartIndexInMixedParts = index;
              }
            }
            setTimeout(() => {
              this.safeSetVideoTime(
                contentTime - durationBefore + part.startTime
              );
            }, 2);
            break;
          } else {
            durationBefore += partDuration;
          }
        }
      }
    },
    setVideoTime(time) {
      let contentVideo = this.$refs.contentVideo;
      if (contentVideo && contentVideo.currentTime !== time) {
        contentVideo.currentTime = time;
      }
    },
    setMusicTime(time) {
      let contentMusic = this.$refs.music;
      if (
        this.audioParameters.musicFile &&
        time > this.audioParameters.musicFile.duration
      ) {
        this.setMusicPlaying(true);
        return;
      }
      if (contentMusic && Math.abs(contentMusic.currentTime - time) > 0.2) {
        contentMusic.currentTime = time;
      }
    },
    setVideoPlaying(isPause) {
      let contentVideo = this.$refs.contentVideo;
      if (contentVideo) {
        if (isPause || this.isPlayingForceDisable) {
          contentVideo.pause();
        } else {
          if (contentVideo.paused) {
            contentVideo.play();
          }
        }
      }
    },
    setMusicPlaying(isPause) {
      let contentMusic = this.$refs.music;
      if (contentMusic) {
        if (isPause || this.isPlayingForceDisable) {
          contentMusic.pause();
        } else {
          if (
            this.contentVideoCurrentTime >
            this.audioParameters.musicFile.duration
          ) {
            contentMusic.pause();
            return;
          }
          if (contentMusic.paused) {
            contentMusic.play();
          }
        }
      }
    },
    muteSound(isMuted) {
      let contentVideo = this.$refs.contentVideo;
      if (contentVideo) {
        if (isMuted) {
          contentVideo.muted = true;
        } else {
          contentVideo.muted = false;
        }
      }
    },
    muteMusicSound(isMuted) {
      let contentMusic = this.$refs.music;
      if (contentMusic) {
        if (isMuted) {
          contentMusic.muted = true;
        } else {
          contentMusic.muted = false;
        }
      }
    },
    setVolume(volume) {
      let contentVideo = this.$refs.contentVideo;
      if (contentVideo) {
        contentVideo.volume = volume / 100;
      }
    },
    setMusicVolume(volume) {
      let contentMusic = this.$refs.music;
      if (contentMusic) {
        contentMusic.volume = volume / 100;
      }
    },
    selectItem(item) {
      this.$store.commit("changeSelectItem", item);
      let contentVideo = this.$refs.contentVideo;
      if (contentVideo) {
        contentVideo.src = item.localSrc
          ? item.localSrc
          : this.$baseURL + item.src;
      }
    },
    getDurationOfPreviousItemsToShowByPart(part) {
      let item = this.itemsToShow.find((i) => i.id === part.parentItemInfo.id);
      return this.getDurationOfPreviousItemsToShow(item);
    },
    getDurationOfPreviousItemsToShow(item) {
      let itemIndex = this.itemsToShow.indexOf(item);
      if (itemIndex === -1) {
        return 0;
      }
      let allDuration = 0;
      for (let index = 0; index < itemIndex; index++) {
        allDuration += this.itemsToShow[index].duration;
      }
      return allDuration;
    },
    convertSecondsToTimeboardStyle(time, isDropFloatPart) {
      return TimeHelper.convertSecondsToTimeboardStyle(time, isDropFloatPart);
    },
  },
});
